import { SCAN_CHECK_TYPE, SCAN_TYPE, SHORT_SCAN_CHECK_TYPE } from "./constants";
import { stringIsReleaseStatus } from "./sdlcMetadataTypeGuards";
/****************************************************
 *                   TYPE GUARDS                    *
 ****************************************************/
export function stringIsScanType(testValue) {
    return SCAN_TYPE.includes(testValue);
}
export function stringIsScanCheckType(testValue) {
    return SCAN_CHECK_TYPE.includes(testValue);
}
export function stringIsScanCheckLabel(testValue) {
    const [reportType, status] = testValue.split(":");
    const isLevelsReport = reportType.startsWith("L") ||
        (reportType[0] === "C" && !Number.isNaN(parseInt(reportType[1])));
    if (!isLevelsReport &&
        !SHORT_SCAN_CHECK_TYPE.includes(reportType))
        return false;
    return stringIsReleaseStatus(status.toLowerCase());
}
//# sourceMappingURL=rlChecksReport.js.map